export default {
    InternalOrderListcompent: {
        Third: 'Third party Order No.',
        Internal: 'CSG Order No.',
        type: 'Order Type',
        status: 'Status',
        store: 'Store',
        channel: 'Sales Channel',
        Payment: 'Payment status',
        line: 'Product line quantity',
        amount: 'Total amount of goods',
        Buyer: 'Buyer payable',
        Total: 'Total cost of goods',
        actual: "Buyer's actual payment",
        Shipment: 'Shipment Status',
        Receiving: 'Receiving status',
        nickname: "Buyer's nickname",
        name: 'Receiver Name',
        phone: 'Phone Number',
        address: 'Consignee address',
        party: 'Three party order placement time',
        time: 'Payment time',
        order: 'ERP Order Time',
        customerTIP: 'Please select the customer first'
    },
};
